import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { StorageService } from './storage.service';
import { throwError } from 'rxjs';
import { InstrumentoAtuevaluacionModel } from '../model/InstrumentoAutoevaluacion.model';

const getInstrumentoAutoevaluacion = 'instrumentoAutoevaluacion/';
const postInstrumentoAutoevaluacion = 'instrumentoAutoevaluacion/';
const postFinalizarInstrumentoAutoevaluacion = 'instrumentoAutoevaluacion/finalizar/';
const postCargarArchivoInstrumentoAutoevaluacion = 'instrumentoAutoevaluacion/cargarArchivo/';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
};
const httpOptionsFile = {

  headers: new HttpHeaders({
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
};
@Injectable({
  providedIn: 'root'
})
export class InstrumentoAutoevaluacionService {

  constructor(private http:HttpClient,private storageService: StorageService) { }

  API_GET_obtenerInstrumentoAutoevaluacion(idJardinPeriodo: number) {
    return this.http.get(environment.apiEndpoint + getInstrumentoAutoevaluacion + idJardinPeriodo, httpOptions).pipe(
        catchError(this.handleError)
    );
  }

  API_POST_guardarInstrumento(idJardinPeriodo: number, insAuto: InstrumentoAtuevaluacionModel) {
    return this.http.post(environment.apiEndpoint + postInstrumentoAutoevaluacion + idJardinPeriodo, insAuto, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_finalizarInstrumento(idJardinPeriodo: number, insAuto: InstrumentoAtuevaluacionModel) {
    return this.http.post(environment.apiEndpoint + postFinalizarInstrumentoAutoevaluacion + idJardinPeriodo, insAuto, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_guardarArchivoIntrumento(idJardinPeriodo: number, dataArchivo: FormData) {
    return this.http.post(environment.apiEndpoint + postCargarArchivoInstrumentoAutoevaluacion + idJardinPeriodo, dataArchivo, httpOptionsFile).pipe(
      catchError(this.handleError)
    );
  }

  handleError(error) {
    let errorMessage = '';
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.message}`;
    return throwError(errorMessage);
  }

}
